const mod = require('react-i18next')

module.exports = {
  ...mod,
  I18nProvider: mod.I18nextProvider
}
